/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const LockFilled: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="lock-filled" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M396.6525000000001 965.26C396.6525000000001 1121.745 523.515 1248.6075 680 1248.6075S963.3475 1121.745 963.3475 965.26V795.26C1025.95 795.26 1076.6950000000002 744.515 1076.6950000000002 681.9125V166.6000000000001H283.3475000000001V681.9125C283.3475000000001 744.5150000000001 334.0925000000001 795.2600000000001 396.6950000000001 795.2600000000001V965.26zM680 1135.26C586.1175000000001 1135.26 510 1059.1425 510 965.26V795.26H850V965.26C850 1059.1425 773.8824999999999 1135.26 680 1135.26zM736.6524999999999 398.5650000000001V568.565H623.305V398.5650000000001H736.6524999999999z" : "M317.322 772.208C317.322 897.396 418.812 998.886 544 998.886S770.6780000000001 897.396 770.6780000000001 772.208V636.208C820.76 636.208 861.3560000000001 595.6120000000001 861.3560000000001 545.53V133.2800000000001H226.6780000000001V545.5300000000001C226.6780000000001 595.6120000000001 267.2740000000001 636.2080000000001 317.3560000000001 636.2080000000001V772.2080000000001zM544 908.208C468.894 908.208 408 847.314 408 772.208V636.208H680V772.208C680 847.314 619.106 908.208 544 908.208zM589.3219999999999 318.852V454.852H498.6439999999999V318.852H589.3219999999999z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
LockFilled.displayName = `Blueprint5.Icon.LockFilled`;
export default LockFilled;
